export const MAX_ORGANIZATION_BRAND_LOGO_BYTES = 512 * 1024;
export const isSquareBrandLogo = (width, height) => width > 0 &&
    height > 0 &&
    Math.abs(width - height) <= Math.max(width, height) * 0.01;
//# sourceMappingURL=organizationBrand.js.map